import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowLeftOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M14.81 24.69a1 1 0 0 0 0-1.48L8.5 17H26a1 1 0 0 0 0-2H8.5l6.31-6.21a1 1 0 0 0 0-1.48 1.07 1.07 0 0 0-1.5 0l-8 7.89A1.1 1.1 0 0 0 5 16a1.13 1.13 0 0 0 .31.8l8 7.89a1.07 1.07 0 0 0 1.5 0" /></svg>;
const ForwardRef = forwardRef(IconArrowLeftOutlineSVG);
ForwardRef.displayName = "IconArrowLeftOutline";
export { ForwardRef as IconArrowLeftOutline };